module.exports = __webpack_public_path__ + "static/media/referral-program-3.1cb4fd62.jpg";